import { AppThemeService } from '@affine/core/modules/theme';
import { useService } from '@toeverything/infra';
import { ThemeProvider as NextThemeProvider, useTheme } from 'next-themes';
import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';

const themes = ['dark', 'light'];

function ThemeObserver() {
  const { resolvedTheme } = useTheme();
  const service = useService(AppThemeService);

  useEffect(() => {
    service.appTheme.theme$.next(resolvedTheme);

    if (typeof document === 'undefined') {
      return;
    }

    const root = document.documentElement;
    if (!resolvedTheme) {
      root.removeAttribute('data-theme');
      root.style.removeProperty('color-scheme');
      return;
    }

    root.setAttribute('data-theme', resolvedTheme);
    root.style.setProperty(
      'color-scheme',
      resolvedTheme === 'dark' ? 'dark light' : 'light dark'
    );

    return () => {
      root.removeAttribute('data-theme');
      root.style.removeProperty('color-scheme');
    };
  }, [resolvedTheme, service.appTheme.theme$]);

  return null;
}

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  return (
    <NextThemeProvider themes={themes} enableSystem={true}>
      {children}
      <ThemeObserver />
    </NextThemeProvider>
  );
};
